import {
  AggregationGroupBy,
  WorkpackTypeFilterOption,
  WorkpackWbsFilterOption,
} from '@/__generated__/graphql';
import { z } from 'zod';

const AGGREGATION_FILTER_OPTIONS: string[] = Object.values(AggregationGroupBy);
const WORKPACK_TYPE_OPTIONS: string[] = Object.values(WorkpackTypeFilterOption);
const WORKPACK_WBS_FILTER_OPTIONS: string[] = Object.values(WorkpackWbsFilterOption);

export const kpiFilterSchema = z.object({
  filters: z.object({
    kpi_date_range: z
      .object({
        to: z.string().optional(),
        from: z.string().optional(),
      })
      .optional(),
    kpi_selected_deployments: z.array(z.string()).min(1).max(2).optional(),
    kpi_aggregation_filter: z.enum(AGGREGATION_FILTER_OPTIONS as [string, ...string[]]).optional(),
    kpi_selected_workpack_types: z
      .array(z.enum(WORKPACK_TYPE_OPTIONS as [string, ...string[]]))
      .max(4)
      .optional(),
    kpi_selected_wbs: z.enum(WORKPACK_WBS_FILTER_OPTIONS as [string, ...string[]]).optional(),
  }),
  columns: z
    .object({
      kpi_table: z.array(z.string()).optional(),
    })
    .optional(),
});
